import { Link } from "react-router-dom";

const base =
  "inline-flex items-center justify-center gap-2 rounded-xl px-6 py-3.5 text-sm font-medium font-body transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-ballk-purple/40";

const styles = {
  primary: "bg-ballk-purple text-white hover:bg-ballk-purple-dark hover:-translate-y-0.5 shadow-[0_10px_30px_-10px_rgba(106,44,160,0.6)]",
  secondary: "bg-white border border-ballk-purple text-ballk-purple hover:bg-ballk-light",
  ghost: "bg-white/10 border border-white/30 text-white hover:bg-white/20",
};

export function Btn({ to, href, variant = "primary", className = "", children, ...props }) {
  const cls = `${base} ${styles[variant]} ${className}`;
  if (to) return <Link to={to} className={cls} {...props}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <button className={cls} {...props}>{children}</button>;
}
